var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('ul',[_c('li',{attrs:{"id":"a"}}),_c('li',{attrs:{"id":"b"}}),_c('li',{attrs:{"id":"c"}}),_c('li',{attrs:{"id":"d"}}),_c('li',{attrs:{"id":"e"}}),_c('li',{attrs:{"id":"f"}}),_c('li',{attrs:{"id":"g"}}),_c('li',{attrs:{"id":"h"}}),_c('li',{attrs:{"id":"i"}})])
}]

export { render, staticRenderFns }